import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: true,
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: "#20275d",
                secondary: "#00b5bc",
                warning: "#f99c1c",
                error: "#f05a40",
                success: "#99cc66",
            },
            dark: {
                primary: "#20275d",
                secondary: "#00b5bc",
                warning: "#f99c1c",
                error: "#f05a40",
                success: "#99cc66",
                black: "#000000",
                white: "#FFFFFF",
            },
        }
    }
});
